
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Mutation, State } from 'vuex-class';
import { TSiteConfigState } from '~/store/types';
import { IProfileState } from '~/store/profile/types';

@Component
export default class PageBottomCtas extends Vue {
  @State((profile: IProfileState) => profile.user.loggedIn, {
    namespace: 'profile',
  })
  loggedIn!: boolean;

  @Getter('siteConfig')
  readonly siteConfigState!: TSiteConfigState;

  get shouldShowFilmNodeBuyPage() {
    return this.siteConfigState?.data?.shouldShowFilmNodeBuyPage;
  }

  @Mutation('toggleRegisterDialog')
  private toggleRegisterDialog!: () => void;
}
